module.exports = __webpack_public_path__ + "static/media/ios-key.c460c5cd.svg";